import React from 'react';
import { useLang, LANGUAGES } from '../../context/LanguageContext';
import { useSiteConfig, resolveImageUrl } from '../../context/SiteConfigContext';

const Header = () => {
  const { lang, setLang } = useLang();
  const { config } = useSiteConfig();
  const nav = config?.nav?.[lang] || { excursions: '', how: '', book: '' };
  const logoUrl = resolveImageUrl(config?.branding?.logo);

  const handleAnchor = (id) => (e) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <header className="sticky top-0 z-40 w-full backdrop-blur bg-[#0e2a24]/90 border-b border-white/5">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3" onClick={handleAnchor('top')}>
          {logoUrl ? (
            <img
              src={logoUrl}
              alt="Exotic Tours Martinique"
              className="h-14 w-14 md:h-16 md:w-16 rounded-full object-cover shadow-lg ring-1 ring-white/20"
            />
          ) : (
            <div className="flex flex-col leading-tight">
              <span className="font-serif text-[15px] tracking-tight text-white">Exotic Tours</span>
              <span className="font-serif text-[15px] tracking-tight text-[#e0b972]">Martinique</span>
            </div>
          )}
        </a>

        <div className="hidden md:flex items-center gap-8 text-[13px] text-white/70">
          <span className="text-white/40">— by Lyonnel</span>
          <a href="#circuits" onClick={handleAnchor('circuits')} className="hover:text-white transition-colors">{nav.excursions}</a>
          <a href="#steps" onClick={handleAnchor('steps')} className="hover:text-white transition-colors">{nav.how}</a>
          <a href="#reserve" onClick={handleAnchor('reserve')} className="hover:text-white transition-colors">{nav.book}</a>
        </div>

        <div className="flex items-center gap-0.5 rounded-full bg-white/5 border border-white/10 p-1">
          {LANGUAGES.map((l) => (
            <button
              key={l.code}
              onClick={() => setLang(l.code)}
              title={l.name}
              aria-label={l.name}
              className={`px-2 py-1.5 text-[15px] leading-none rounded-full transition-all ${
                lang === l.code
                  ? 'bg-white/95 shadow-sm scale-105'
                  : 'opacity-55 hover:opacity-100 hover:bg-white/5'
              }`}
            >
              <span role="img" aria-hidden>{l.flag}</span>
            </button>
          ))}
        </div>
      </div>
    </header>
  );
};

export default Header;
